import {PILL_CLASS} from '../pill/constants'


// "Is the editor logically empty?" — used to toggle the `is-empty`
// placeholder class on the editor element.
//
// `:empty::before` is unreliable in contenteditable because browsers
// leave stray `<br>` nodes and empty text nodes behind after typing-
// and-deleting; this JS check inspects the actual content instead.
//
// A pill counts as content; `<br>` elements and zero-width spacer
// text nodes do not.
export function textareaWithVariables_isLogicallyEmpty(root: Node): boolean {
    const stack: Node[] = Array.from(root.childNodes)
    while (stack.length) {
        const n = stack.pop()!
        if (n.nodeType === Node.TEXT_NODE) {
            const txt = (n.textContent || '').replace(/​/g, '')
            if (txt.length > 0) return false
            continue
        }
        if (n.nodeType !== Node.ELEMENT_NODE) continue
        const el = n as HTMLElement
        if (el.tagName === 'BR') continue
        if (el.classList.contains(PILL_CLASS)) return false
        for (const child of Array.from(el.childNodes)) stack.push(child)
    }
    return true
}
